<template>
  <div class="gwhome">

     <!-- 自定义提示框 -->
    <div class="alsrtInfo" :style="{display: displayStsates}" ref="alertMsg">
      <div class="profPrompt_test">{{aletMsg}}</div>
    </div>

    <div class="title">
      <img src="../../images/lujing.png" alt class="title_Img" @click="_return()" />
      <div class="title_Div">购物车</div>
    </div>
    <div>
      <!-- 无订单显示 -->
      <div class="gw" v-if="show">
        <img src="../../images/gwc_eee.png" alt />
        <p>您的购物车内还没有任何商品</p>
        <div class="btn_gm" @click.stop="go_gm()">去购物</div>
      </div>
      <!-- 广告end -->
      <van-loading
        v-show="addOff"
        color="#1989fa"
        id="loading_add"
        size="24px"
        vertical
      />
      <!-- // 有订单显示 -->
      <div class="content_list">
        <!-- 购物车列表循环遍历list，item的count如果为0，则代表此条数据不需要渲染 -->
        <div class="item_Div" v-for="(item,index) in list" v-if="item.count > 0" :key="index">
          <div class="item_Div_img_div">
            <img
              src="../../images/lmj_hou.png"
              alt
              class="item_Div_img_div_img"
              v-if="item.selected == 2"
              @click="xuanze(index,item.id,1)"
            />
            <img
              src="../../images/lmj_qian.png"
              alt
              class="item_Div_img_div_img"
              v-else
              @click="xuanze(index, item.id,2)"
            />
          </div>
          <div class="item_Div_right">
            <img :src="item.face" alt class="item_Img" />
            <div class="item_Right">
              <div class="item_Right_top">
                <div class="item_Right_top_left">{{item.name}}</div>
                <img
                  src="../../images/lmj_delete.png"
                  alt
                  class="item_Right_top_right"
                  @click="deletes(index,item.id)"
                />
              </div>
              <div class="item_Right_bottom">
                <div class="item_Right_bottom_left">
                  <span>￥{{item.money}}元</span>
                </div>
                <div class="item_Right_bottom_right">
                  <button
                  :disabled='btnShow'
                    class="stepper__minus"
                    @click="
                amend(
                item.count =  item.count <= 1? 1: parseInt(item.count) - 1,
                item,
                index
                )"
                  ></button>
                  <input
                    type="number"
                    class="van-stepper__input"
                    v-model="item.count"
                    @blur="amend(item.count =  item.count <= 1? 1: parseInt(item.count), item, index )"
                  />
                  <button
                  :disabled='btnShow'
                    class="stepper__plus"
                    @click="
                amend(
                item.count= parseInt(item.count) + 1,
                item,
                index
                )"
                  ></button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="buttom" v-for="(item,index) in list" v-if="item.count > 0">
        <div class="buttom_one">合计：</div>
        <div class="buttom_two">￥</div>
        <div class="buttom_three">{{num}}元</div>
        <div class="buttom_btn" v-on:click="placeorder()">下单&nbsp;&nbsp;({{sum}})</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../../lmj_Api/api";

export default {
  data() {
    return {
      name: "Home",
      uid: this.$store.getters.get_user_id,
      list: "",
      show: false,
      count: "",
      num: "", //选中的数量
      sum: "", //总钱
      aletMsg: "", // 弹框提示语
      displayStsates: "none",
      btnShow:false,
      addOff:false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(from, "sj"); // 上一页面的路由信息
      if (from.name != "shoppingcart") {
        localStorage.to_gwc = from.name;
      }
      console.log(localStorage.to_gwc, "上一个进入的页面"); // 上一页面的路由信息
    });
  },
  mounted() {
    var that = this;
    that.init();
  },
  methods: {
    // 点击去购买
    go_gm() {
      this.$router.push({ name: "lmjhome" });
    },

    //返回上一页
    _return() {
      console.log(localStorage.to_gwc, "上一个进入的页面"); // 上一页面的路由信息
      if (localStorage.to_gwc == "lmjhome") {
        this.$store.commit('bottom_nav', 1)
          if (this.$route.path !== '/lmjhome') {
            this.$router.push({ name: "lmjhome" });
           }

      } else if (localStorage.to_gwc == "hyhome") {
        this.$router.push({ path: "/hyhome" });
      }
    },

    //初始化加载请求数据
    init() {
      var that = this;
      this.axios.post(API.ShoppingCart, { user_id: that.uid }).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          that.list = res.data.data;
          console.log(that.list);
          that.num = res.data.money;
          that.sum = res.data.count;
          that.show = true;
          for (var i = 0; that.list.length > i; i++) {
            if (that.list[i].count != 0) {
              that.show = false;
            }
          }
        }
      });
    },

    // 单选框
    xuanze(index, goods_id, status) {
      //选中后的回调
      var that = this;
      var ajax = () => {
        var url = API.count;
        that.axios
          .post(url, {
            user_id: that.uid,
            id: goods_id,
            selected: status,
            type: 3
          })
          .then(res => {
            if (res.data.code == 200) {
              that.num = res.data.data.money;
              that.sum = res.data.data.count;
            }
            console.log(res);
          });
      };
      if (status == 1) {
        console.log(goods_id, status);
        that.list[index].selected = 1;
        ajax();
        return;
      } else {
        that.list[index].selected = 2;
        ajax();
      }
    },
    // 删除
    deletes(e, id) {
      var that = this;
      var url = API.count;
      this.$dialog
        .confirm({
          // title: "删除",
          message: "确定删除",
          width: "5.46rem",
          className: "tit"
        })
        .then(() => {
          this.axios
            .post(url, {
              id: id,
              type: 2
            })
            .then(res => {
              if (res.data.code == 200) {
                that.init();
              }
            });
        })
        .catch(() => {});
    },

    //改变购物车里的数量
    amend(_null, obj, index) {
      this.btnShow = true;
      var url = API.ShopAdd;
      var thar = this;
      // setTimeout(()=>{
        this.axios
        .post(url, {
          user_id: thar.uid,
          shop_id: obj.shop_id,
          count: obj.count,
          money: obj.money,
          name: obj.name
        }).then(res => {
          if (res.data.code == 200) {
            thar.num = res.data.money;
          }
           thar.btnShow = false
        });
      // },500)
    },
    // 下单
    placeorder() {
      var arr_parameter = [];
      var url = API.orderDetails;
      var thar = this;
      var off = false;
      for (var i = 0; this.list.length > i; i++) {
        //确认提交订单btn 要求两点
        //不为0件的
        //selected为2的开关==true
        if (this.list[i].count != 0 && this.list[i].selected == 2) {
          off = true;
          arr_parameter.push(this.list[i].id);
        }
      }
      if (off) {
        this.axios
          .post(url, {
            uid: thar.uid,
            id: arr_parameter.join(",")
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$store.commit('bottom_nav', 1)
              this.$router.push({
                name: "shoppingcart",
                params: {
                  id: arr_parameter.join(",")
                }
              });
            }
          });
      } else {
        // alert('请选择一件商品')
        this.alertDia("请选择一件商品")
      }
    },
    //自定义弹框
       alertDia(msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1000);
    },
  },
  watch: {
    list: function(newVal) {
      this.count = newVal + "-" + this.count;
      console.log(this.count);
    }
  },
};
</script>
<style lang="less" scoped>
#app>div{
  height: 0;
}
.gwhome {
  width: 100%;
  // height: 100%;
  // height:  calc(~"(100% - 2.1rem)");
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 400;
  //购物车 无列表
  .gw {
    height: calc(~"(100%-1.88rem)");
    padding-top: 1.88rem;
    img {
      display: block;
      height: 3.74rem;
      width: 3.78rem;
      margin: 0rem auto 0;
    }
    p {
      color: #999;
      font-size: 0.32rem;
      margin: 0.54rem 0 0;
      text-align: center;
    }
    .btn_gm {
      width: 2.56rem;
      height: 0.96rem;
      font-size: 0.32rem;
      border-radius: 0.48rem;
      background: linear-gradient(
        90deg,
        rgba(123, 212, 255, 1) 0%,
        rgba(92, 186, 255, 1) 100%
      );
      margin: 0.88rem auto;
      text-align: center;
      line-height: 0.96rem;
      color: #fff;
      font-weight: 500;
    }
  }

  // 有列表
  .title {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.88rem;
    background: linear-gradient(
      90deg,
      rgba(123, 212, 255, 1) 0%,
      rgba(92, 186, 255, 1) 100%
    );
    display: flex;
    align-items: center;
    text-align: center;
    .title_Img {
      width: 0.18rem;
      height: 0.34rem;
      margin-left: 0.44rem;
    }
    .title_Div {
      width: auto;
      height: 0.42rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.42rem;
      margin-left: 2.68rem;
    }
  }
  .content_list {
    width: 100%;
    height: calc(~"(100% - 2.1rem)");
    padding-top: 0.88rem;
    padding-bottom: 1.22rem;
  }
  .item_Div {
    width: 100%;
    height: 2.2rem;
    border-bottom: 0.02rem solid rgba(237, 237, 237, 1);
    display: flex;
    .item_Div_img_div {
      width: 1rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .item_Div_img_div_img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
    .item_Div_right {
      width: 6.5rem;
      height: 100%;
      display: flex;
      .item_Img {
        width: 1.7rem;
        height: 1.7rem;
        margin-top: 0.24rem;
      }
      .item_Right {
        width: 4.8rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        .item_Right_top {
          width: 100%;
          height: 0.84rem;
          margin-top: 0.24rem;
          display: flex;
          .item_Right_top_left {
            width: 2.9rem;
            height: 0.84rem;
            font-size: 0.3rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(74, 74, 74, 1);
            line-height: 0.42rem;
            margin-left: 0.28rem;
          }
          .item_Right_top_right {
            width: 0.32rem;
            height: 0.32rem;
            margin-left: 1rem;
            margin-top: 0.02rem;
          }
        }
        .item_Right_bottom {
          width: 100%;
          height: 0.42rem;
          margin-top: 0.44rem;
          display: flex;
          .item_Right_bottom_left {
            width: 2.55rem;
            height: 0.42rem;
            font-size: 0.3rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(255, 93, 51, 1);
            line-height: 0.42rem;
            margin-left: 0.2rem;
          }
          .item_Right_bottom_right {
            width: 1.68rem;
    height: 0.52rem;
    margin-top: -0.05rem;
    // margin-left: 0.2rem;
    display: flex;
            button {
              border-radius: 50%;
              background: #d8d8d8;
              font-weight: 700;
              // width: 0.42rem;
              // height: 0.42rem;
              color: rgba(255, 255, 255, 1);
              font-size: 0.16rem;
            }
            :nth-child(3) {
              background: #5dbbff;
            }
            input {
              height: 0.42rem;
              font-size: 0.3rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(74, 74, 74, 1);
              line-height: 0.42rem;
              background: #fff;
            }
          }
        }
      }
    }
  }
  .buttom {
    width: 100%;
    height: 1.2rem;
    background: rgba(255, 255, 255, 1);
    position: fixed;
    bottom: 0rem;
    display: flex;
    align-items: center;
    z-index: 999;
    .buttom_one {
      width: 0.9rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(74, 74, 74, 1);
      margin-left: 0.32rem;
    }
    .buttom_two {
      font-size: 0.24rem;
      color: #ff5d33;
      margin-top: 0.1rem;
    }
    .buttom_three {
      font-size: 0.4rem;
      width: 3.7rem;
      color: #ff5d33;
      font-weight: bold;
    }
    .buttom_btn {
      height: 0.96rem;
      width: 2.2rem;
      line-height: 0.96rem;
      text-align: center;
      background: linear-gradient(
        90deg,
        rgba(123, 212, 255, 1) 0%,
        rgba(92, 186, 255, 1) 100%
      );
      border-radius: 0.2rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      float: right;
      // margin-right: ;
      // margin-left: 2.94rem;
    }
  }

.alsrtInfo {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  .profPrompt_test {
    width: 4.2rem;
    height: 1.4rem;
    line-height: 1.4rem;
    border-radius: 0.2rem;
    color: #fff;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0.6;
    top: 5.98rem;
    left: 50%;
    font-size: 0.28rem;
    font-family: Gotham-Book;
    opacity: 1;
    text-align: center;
    transform: translate(-50%, -50%);
  }
}

}
</style>
// 全局步进器样式
<style>
.stepper__minus {
  display: inline-block;
  border: none;
  z-index: 9;
  width: 0.5rem !important;
  height: 0.5rem !important;
  color: rgba(0, 0, 0, 0);
  background: url("../../images/hb_eee.png") no-repeat !important;
  background-position: 0px 0px;
  background-size: 0.5rem 0.5rem !important;
}
.van-stepper__input {
  width: 0.6rem !important;
  height: 0.52rem !important;
  background: none !important;
  padding: 0rem !important;
  border: none !important;
  margin: 0rem !important;
}
/* .stepper__plus {
  height: 0.475rem;
  width: 0.47rem;
  z-index: 99;
  color: rgba(0, 0, 0, 0);
  background: url("../../images/hb7.png") no-repeat !important;
  background-position: 0px -0.04rem !important;
  background-size: 0.47rem 0.47rem !important;
} */
.stepper__plus {
  display: inline-block;
  height: 0.6rem;
  border: none;
  width: 0.6rem;
  margin-top: -0.02rem;
  z-index: 99;
  color: rgba(0, 0, 0, 0);
  background: url('../../images/hb7.png') no-repeat !important;
  background-position: 0px -0.02rem !important;
  background-size: 0.55rem 0.55rem !important;
}

/* .el-select .el-input__inner, .el-input--suffix .el-input__inner { */
/* padding: 0 $dim_spacing_large5; */
/* } */
</style>



// WEBPACK FOOTER //
// src/components/lcx/home.vue